function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "uk");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "nc-icon-wrapper"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46,6H2A2,2,0,0,0,0,8V40a2,2,0,0,0,2,2H46a2,2,0,0,0,2-2V8A2,2,0,0,0,46,6Z",
  fill: "#002781"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48,8a2,2,0,0,0-2-2H40.839L28,15.876V6H20v9.876L7.161,6H2A2,2,0,0,0,0,8v2.586L12.239,20H0v8H12.239L0,37.415V40a2,2,0,0,0,2,2H7.161L20,32.124V42h8V32.124L40.839,42H46a2,2,0,0,0,2-2V37.415L35.761,28H48V20H35.761L48,10.586Z",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "48 22 26 22 26 6 22 6 22 22 0 22 0 26 22 26 22 42 26 42 26 26 48 26 48 22",
  fill: "#d10d24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,27.723,1.582,41.955A2.051,2.051,0,0,0,2,42H4.386L20,29.935Z",
  fill: "#d10d24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28,20.277,46.418,6.045A2.058,2.058,0,0,0,46,6H43.614L28,18.066Z",
  fill: "#d10d24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.006,20,.615,6.562A1.989,1.989,0,0,0,0,8v.3L15.144,20Z",
  fill: "#d10d24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.994,28,47.385,41.438A1.989,1.989,0,0,0,48,40v-.3L32.856,28Z",
  fill: "#d10d24"
}));

var SvgUk = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/uk.2438f86f.svg";
export { ForwardRef as ReactComponent };